import type { CardContentMaxWidth } from '@/lib/types';
import { cleanObject } from '@/lib/util';
import { theme } from '@/theme';

import type { CardProps } from '../../types';
import { getDeskTopMaxContentWidth } from '../BaseCardType/helpers';
import { CardContent } from '../CardContent';

import * as S from './IntroText.styles';

export const IntroText = (_props: CardProps) => {
  const props: CardProps = {
    contentAlignment: 'center',
    textAlignment: 'center',
    type: 'default',
    urlType: 'button',
    ...cleanObject(_props),
  };
  // text card has no min-height
  const withWrapperMinHeight = false;
  // text card has no withBackgroundImage
  // text card has background color
  const backgroundColor = {
    ...props?.backgroundColor,
    value: props.backgroundColor?.value || theme.colors.white,
  };
  // text card has heading color
  const processedProps = {
    ...props,
    withWrapperMinHeight,
    backgroundColor,
  };

  const deskTopContentMaxWidth = getDeskTopMaxContentWidth(
    processedProps.type as string,
    processedProps.contentMaxWidth as CardContentMaxWidth,
  );

  return (
    <S.Content
      className={`${processedProps.className}Content`}
      data-test-id='BaseCardTypeContent'
      deskTopContentMaxWidth={deskTopContentMaxWidth}
      textAlignment={processedProps.textAlignment}
    >
      <CardContent {...processedProps} />
    </S.Content>
  );
};
